module.exports = __webpack_public_path__ + "img/delete_white.53229ff3.svg";